<template lang="html">
    <v-container fluid class="">
        <div class="dashboard-page">

            <v-card>

                <v-card-title class="pa-5 pb-3 primary">
                    <v-toolbar-title style="color: white;">
                        {{ this.tittle }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon>mdi-file-document</v-icon>
                </v-card-title>


                <!--<p style="MARGIN-TOP: 4%; margin-left: 7%; margin-bottom: -2%; font-weight: 600; color: dimgray; margin-top: 3%;">Tipo de documento: {{this.docDes}}</p>-->

                <v-card-text>

                    <v-container fill-height>
                        <v-row justify="center" align="center" style="margin-top: 2%;">
                            <v-col cols="14" sm="6">
                                <span class="text-h5">Tipo de documento: {{ nombreArchivo }}</span><span
                                    class="text-h5">
                                    {{ this.contador }}</span>/<span class="text-h5">{{ this.paginas
                                    }}</span><v-spacer></v-spacer>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-progress-linear :active="loading" :indeterminate="loading" color="primary" class="mb-0">


                    </v-progress-linear>

                    <v-row justify="center" style="margin-top: 2%;">

                        <div class="btnSI">
                            <v-col class="justify-center align-center" cols="12" md="1" align="center" xs="4"
                                justify="center">

                                <v-container bg fill-height grid-list-md text-xs-center>
                                    <v-layout row wrap align-center>
                                        <v-flex>
                                            <v-btn icon class="ma-2 align-center" @click="Anterior()"
                                                :loading="loading2" :disabled="disable1">
                                                <v-icon>
                                                    mdi-chevron-left
                                                </v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-col>
                        </div>

                        <div class="btnSI">
                            <v-col cols="12" md="1">


                                <v-container bg fill-height grid-list-md text-xs-center>
                                    <v-layout row wrap align-center>
                                        <v-flex>
                                            <v-btn icon class="ma-2 align-center" @click="Siguiente()"
                                                :loading="loading3" :disabled="disable2">
                                                <v-icon>
                                                    mdi-chevron-right
                                                </v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-col>
                        </div>


                    </v-row>

                    <v-row justify="center" style="margin-top: 2%;">


                        <v-col class="hidden-sm-and-down justify-center align-center" cols="12" md="1" align="center"
                            xs="4" justify="center">

                            <v-container bg fill-height grid-list-md text-xs-center>
                                <v-layout row wrap align-center>
                                    <v-flex>
                                        <v-btn icon class="ma-2 align-center" @click="Anterior()" :loading="loading2"
                                            :disabled="disable1">
                                            <v-icon>
                                                mdi-chevron-left
                                            </v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-col>





                        <v-col cols="12" md="10">
                            <div id="ver" style="border-radius: 10%;">

                            </div>
                        </v-col>


                        <v-col cols="12" md="1">


                            <v-container bg fill-height grid-list-md text-xs-center>
                                <v-layout row wrap align-center>
                                    <v-flex>
                                        <v-btn icon class="hidden-sm-and-down ma-2 align-center" @click="Siguiente()"
                                            :loading="loading3" :disabled="disable2">
                                            <v-icon>
                                                mdi-chevron-right
                                            </v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-col>



                    </v-row>
                </v-card-text>


                <v-row align="center" class="justify-center pa-5 pb-3" style="margin-top: 2%; padding-bottom: 0; ">
                    <v-col class="d-flex" cols="6" sm="6">
                        <!--<p style="font-weight: 600;color: dimgray;">Documentaci&oacuten Correcta</p>-->
                        <span style="color: black; text-align: center;">Documentaci&oacuten Correcta:</span>
                    </v-col>
                </v-row>
                <v-row align="center" class="justify-center" style="margin-top: 0;">
                    <v-col cols="12" class="py-2 justify-center pa-5 pb-3 row justify-center pa-5 pb-3 align-center">


                        <v-btn-toggle v-model="selectedItem" variant="outlined" background-color="deep-purple accent-3"
                            group>


                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-btn color="blue darken-2" text value="S" class="mr-1">
                                            <v-icon icon large color="blue darken-2">mdi-thumb-up</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <span>Conforme</span>
                            </v-tooltip>


                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-btn color="red darken-2" text value="N" class="mr-1"
                                            :rules="[v => (v || '').length >= 12 || 'La observación debe ser mayor a 12 caracteres']">
                                            <v-icon icon large color="red darken-2">mdi-thumb-down</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <span>No Conforme</span>
                            </v-tooltip>


                        </v-btn-toggle>

                    </v-col>



                </v-row>


                <v-row align="center" class="justify-center pa-5 pb-3"
                    style="margin-top: 0px; padding-bottom: 0; margin-top: -2%; ">
                    <v-col class="d-flex" cols="6" sm="6">
                        <span style="color: black; text-align: center;">Observaciones:</span>

                    </v-col>
                </v-row>

                <v-form id="observ" v-model="valid" ref="form" lazy-validation>
                    <v-row align="center" justify="center" class="justify-center" style="margin-top: -2%;">
                        <v-col align="center" xs="10" md="6" sm="10" class="d-flex justify-center">
                            <v-textarea outlined v-model="obs" name="input-7-4" :counter="500" required
                                :rules="descRules" label=""></v-textarea>
                        </v-col>



                    </v-row>
                </v-form>

                <v-row align="center" class="justify-center">
                    <v-alert :value="alert" color="red" type="warning" transition="scale-transition">
                        {{ this.alertText }}
                    </v-alert>



                </v-row>


                <v-card-actions class="justify-center" style="margin-bottom: 5%;">
                    <v-btn depressed :disabled="!valid" color="primary" @click="alert = false; CalifDocMov()"
                        style="margin-right: 4%;">
                        Guardar
                    </v-btn>

                    <v-btn depressed color="error" @click="$router.push({ name: `DocumentosView` });">
                        Cancelar
                    </v-btn>
                </v-card-actions>


                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span style="padding-left: 25%;">Registro con éxitoso</span>
                            <!--<p style="text-align: center; font-size: 20px; font-weight: 700; margin-top: 2%; ">Validaci�n inicial de documentos</p>-->
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-actions class="justify-center">
                            <v-btn color="primary" @click="$router.go(-1), dialog = false">Cerrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>



            </v-card>



        </div>
    </v-container>
</template>
<style>
.v-data-table-header th {
    white-space: nowrap;
}

.calfCol {
    padding-left: 30%;
}


@media (max-width: 600px) {
    .btnNO {
        display: none;
    }


    .btnSI {
        display: block;
    }
}

@media (min-width: 601px) {
    .btnNO {
        display: flex;
    }

    .btnSI {
        display: none;
    }
}
</style>

<script>
import { mapState } from 'vuex';
import Documentos from '@/services/Documentos/documentos.service.js';
import utils from '@/utils/managerLocalStorage.js';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    components: {

    },
    data() {
        return {
            verarchi: false,
            loading: false,
            loading2: false,
            loading3: false,
            docs: [],
            CalfItems: [
                { value: 'S', respDoc: 'Conforme' },
                { value: 'N', respDoc: 'No Conforme' },
            ],
            /*CalfItems: ['Conforme', 'No Conforme'],*/
            reporte: [],
            docId: '',
            doClave: '',
            docDes: '',
            selectedItem: null,
            obs: '',
            dialog: false,
            alert: false,
            alertText: '',
            asegurado: '',
            ceclave: '',
            tittle: '',
            valid: true,
            paginas: 0,
            contador: 1,
            disable1: false,
            disable2: false,
            descRules: [
                (v) => !!v || "Campo requerido",
                (v) =>
                    (v && v.length >= 12) ||
                    "Mínimo 12 Carácteres",
                (v) =>
                    (v && v.length <= 500) ||
                    "Máximo 500 Carácteres",
            ],
            nombreArchivo: '',
        };
    },

    methods: {
        Anterior() {
            this.disable1 = true;

            if (this.contador == 1) {
                this.contador == 1;
                this.disable1 = true;
            }
            else {
                this.loading = true;
                this.loading3 = true;
                this.loading2 = true;
                this.disable1 = false;
                this.disable2 = false;
                this.contador = this.contador - 1


                if (document.querySelector("iframe") != null) {
                    document.querySelector("iframe").remove();
                }


                this.BurcarArchivo();

            }

        },
        Siguiente() {

            this.disable2 = true;
            if (this.contador == this.paginas) {
                this.contador = this.paginas;
                this.disable2 = true;
            }
            else {
                this.loading = true;
                this.loading3 = true;
                this.loading2 = true;
                this.disable2 = false;
                this.disable1 = false;
                this.contador = this.contador + 1


                if (document.querySelector("iframe") != null) {
                    document.querySelector("iframe").remove();
                }

                this.BurcarArchivo();
            }

        },
        VerArchivo(docid, tipo, dodescrip, paginas) {
            this.paginas = paginas;
            this.nombreArchivo = this.docDes;
            this.loading = true;
            this.verarchi = true;
            /*this.docid = docid;*/


            var formData = new FormData();
            formData.append("nrreporte", this.reporte.nrreporte);
            formData.append("svindice", this.reporte.svindice);
            formData.append("docid", this.docId);
            formData.append("pagina", 1);

            Documentos.ObtenerDireccion(this, formData).then(data => {
                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", tipo);
                formData.append("laaccion", "Ver Documentos");
                formData.append("lacaracteristicas", this.reporte.nrreporte + '-' + this.reporte.svindice);
                formData.append("lanombre", data.archivo);
                formData.append("ladestinatario", "");

                if (data == "Failed") {

                    document.getElementById('ver').appendChild("No se pudo recuperar el archivo");

                }
                else {
                    Documentos.AlmacenarVisitas(this, formData).then(data => {
                    });
                    if (data.archivo !== null) {
                        //this.Visitas(tipo, 'Docuemntos' + tipo, data.archivo, "");
                        this.nombreArchivo = dodescrip;
                        var iframe = document.createElement("iframe");
                        iframe.setAttribute("src", data.watch);
                        iframe.style.width = "100%";
                        iframe.style.height = "800px";
                        iframe.style.borderRadius = "1%";
                        iframe.style.border = "solid gray 1px";
                        document.getElementById('ver').appendChild(iframe);
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: data.msg,
                            showConfirmButton: false,
                            timer: 2500
                        });
                        this.verarchi = false;
                    }
                }

            });
        },
        BurcarArchivo() {

            var formData = new FormData();
            formData.append("nrreporte", this.reporte.nrreporte);
            formData.append("svindice", this.reporte.svindice);
            formData.append("docid", this.docId);
            formData.append("pagina", this.contador);

            Documentos.ObtenerDireccion(this, formData).then(data => {
                /* var formData = new FormData();
                formData.append("lasitio", 'Siniestros');
                formData.append("lomodulo", tipo);
                formData.append("laaccion", "Ver Documentos");
                formData.append("lacaracteristicas", this.reporte.nrreporte + '-' + this.reporte.svindice);
                formData.append("lanombre", data.archivo);
                formData.append("ladestinatario", "");
                Documentos.AlmacenarVisitas(this, formData).then(data => {
                });*/
                if (data.archivo !== null) {
                    //this.Visitas(tipo, 'Docuemntos' + tipo, data.archivo, "");
                    //this.nombreArchivo = dodescrip;
                    var iframe = document.createElement("iframe");
                    iframe.setAttribute("src", data.watch);
                    iframe.style.width = "100%";
                    iframe.style.height = "800px";
                    iframe.style.borderRadius = "1%";
                    iframe.style.border = "solid gray 1px";

                    document.getElementById('ver').appendChild(iframe);
                }
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Error',
                        text: data.msg,
                        showConfirmButton: false,
                        timer: 2500
                    });
                    this.verarchi = false;
                }
                this.loading2 = false;
                this.loading3 = false;
            });

        },
        CerrarVisor() {
            this.verarchi = false;
            document.querySelector("iframe").remove();
        },
        async CalifDocMov() {


            this.obs = this.obs.trim();

            await this.$refs.form.validate();

            if (this.$refs.form.validate()) {

                if (this.selectedItem == null) {


                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Error',
                        text: 'Selecciona la calificación del documento',
                        showConfirmButton: true,
                        timer: 2500
                    });

                    return;
                }



                this.$swal({

                    position: 'center',

                    title: 'Guardando Movimiento, espere un momento....',

                    allowEscapeKey: false,

                    allowOutsideClick: false,

                    didOpen: () => {

                        this.$swal.showLoading();

                    }

                });




                var formData = new FormData();
                var nextStep = false;
                formData.append("nrreporte", this.reporte.nrreporte);
                formData.append("svindice", this.reporte.svindice);
                formData.append("resp", this.selectedItem);
                formData.append("obs", this.obs);
                formData.append("doclave", this.doClave);
                formData.append("docID", this.docId);
                formData.append("usLogin", utils.getSingleValueInLocalStorage(this.$store.state.informationPage.nameCookiePGV2));
                formData.append("ceclave", this.ceclave);

                Documentos.ValidacionDocsEsc(this, formData).then(data => {
                    nextStep = true;
                    if (data == true) {

                        var formData = new FormData();
                        formData.append("nrreporte", this.reporte.nrreporte);
                        formData.append("svindice", this.reporte.svindice);
                        formData.append("resp", this.selectedItem);
                        formData.append("obs", this.docDes + "//" + " " + this.obs);
                        formData.append("docID", this.docId);
                        formData.append("ceclave", this.ceclave);
                        Documentos.MovimientoValidacionDocs(this, formData).then(data2 => {


                            console.log("Antes del if");

                            if (data2 == true) {


                                console.log("Entre al if");
                                var formData = new FormData();
                                formData.append("nrreporte", this.reporte.nrreporte);
                                formData.append("svindice", this.reporte.svindice);
                                formData.append("ceclave", this.ceclave);
                                Documentos.ListaObs(this, formData).then(data3 => {



                                });
                                this.$swal.close();

                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Movimiento realizado',
                                    text: 'Movimiento realizado',
                                    showConfirmButton: true,
                                    timer: 5500
                                }).then(() => {

                                    this.$router.push({ name: `DocumentosView` })
                                });
                                if (this.selectedItem == 'N') {
                                    var formData = new FormData();
                                    var asegObj = this.asegurado.split('-');

                                    formData.append("correos", asegObj[1]);
                                    formData.append("nrreporte", this.reporte.nrreporte + '-' + this.reporte.svindice);
                                    formData.append("tipoDoc", this.docDes);
                                    formData.append("obs", this.obs);
                                    formData.append("aseg", asegObj[0]);
                                    formData.append("ceclave", this.ceclave);

                                    Documentos.EnviarCorreo(this, formData).then(data5 => {


                                    });


                                }
                            }



                        });
                    }


                });


                nextStep = true;

                if (nextStep == true) {


                }


            }


        },
        async CalifDocMov() {

            this.obs = this.obs.trim();

            await this.$refs.form.validate();

            if (this.$refs.form.validate()) {
                if (this.selectedItem == null) {


                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Error',
                        text: 'Selecciona la calificación del documento',
                        showConfirmButton: true,
                        timer: 2500
                    });

                    return;
                }



                this.$swal({

                    position: 'center',

                    title: 'Guardando Movimiento, espere un momento....',

                    allowEscapeKey: false,

                    allowOutsideClick: false,

                    didOpen: () => {

                        this.$swal.showLoading();

                    }

                });




                var formData = new FormData();
                var nextStep = false;
                formData.append("nrreporte", this.reporte.nrreporte);
                formData.append("svindice", this.reporte.svindice);
                formData.append("resp", this.selectedItem);
                formData.append("obs", this.obs);
                formData.append("doclave", this.doClave);
                formData.append("docID", this.docId);
                formData.append("usLogin", utils.getSingleValueInLocalStorage(this.$store.state.informationPage.nameCookiePGV2));
                formData.append("ceclave", this.ceclave);

                Documentos.ValidacionDocsEsc(this, formData).then(data => {
                    nextStep = true;
                    if (data == true) {

                        var formData = new FormData();
                        formData.append("nrreporte", this.reporte.nrreporte);
                        formData.append("svindice", this.reporte.svindice);
                        formData.append("resp", this.selectedItem);
                        formData.append("obs", this.docDes + "//" + " " + this.obs);
                        formData.append("docID", this.docId);
                        formData.append("ceclave", this.ceclave);
                        Documentos.MovimientoValidacionDocs(this, formData).then(data2 => {

                            if (data2 == true) {

                                var formData = new FormData();
                                formData.append("nrreporte", this.reporte.nrreporte);
                                formData.append("svindice", this.reporte.svindice);
                                formData.append("ceclave", this.ceclave);
                                Documentos.ListaObs(this, formData).then(data3 => {



                                });
                                this.$swal.close();

                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Movimiento realizado',
                                    text: 'Movimiento realizado',
                                    showConfirmButton: true,
                                    timer: 5500
                                }).then(() => {

                                    this.$router.push({ name: `DocumentosView` })
                                });
                                if (this.selectedItem == 'N') {
                                    var formData = new FormData();
                                    var asegObj = this.asegurado.split('-');

                                    formData.append("correos", asegObj[1]);
                                    formData.append("nrreporte", this.reporte.nrreporte + '-' + this.reporte.svindice);
                                    formData.append("tipoDoc", this.docDes);
                                    formData.append("obs", this.obs);
                                    formData.append("aseg", asegObj[0]);
                                    formData.append("ceclave", this.ceclave);

                                    Documentos.EnviarCorreo(this, formData).then(data5 => {


                                    });


                                }
                            }



                        });
                    }


                });


                nextStep = true;

                if (nextStep == true) {


                }

            }



        }
    },

    created: function () {

    },

    computed: {
        ...mapState(["domain", "theme"]),
        ...mapState("Operacion", ["key"]),

    },
    async mounted() {
        //this.docDes = utils.getSingleValueInLocalStorage('idDes');
        //this.docId = utils.getSingleValueInLocalStorage('idDoc');
        //this.doClave = utils.getSingleValueInLocalStorage('doclave');
        //this.reporte = utils.getSingleValueInLocalStorage('reporte');
        //this.asegurado = utils.getSingleValueInLocalStorage('aseg');
        //this.ceclave = utils.getSingleValueInLocalStorage('ceclave');
        //this.paginas = utils.getSingleValueInLocalStorage('docpaginas');


        this.docDes = sessionStorage.getItem('idDes');
        this.docId = sessionStorage.getItem('idDoc');
        this.doClave = sessionStorage.getItem('doclave');
        this.reporte = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.asegurado = sessionStorage.getItem('aseg');
        this.ceclave = sessionStorage.getItem('ceclave');
        if (sessionStorage.getItem('docpaginas').toString().includes("object")) {
            this.paginas = 0;
            this.disable2 = true;
            this.disable1 = true;
        }
        else {
            this.paginas = sessionStorage.getItem('docpaginas');

            if (this.paginas == 1) {

                this.disable1 = true;
                this.disable2 = true;
            } else if (this.paginas > 1) {

                this.disable1 = true;
                this.disable2 = false;
            }
        }




        if (this.ceclave == 828) {
            this.tittle = 'Validación de documentación digital';
        }
        else if (this.ceclave == 829) {
            this.tittle = 'Validación de documentación legal';
        }
        else if (this.ceclave == 830) {
            this.tittle = 'Validación de documentación física';
        }


        this.VerArchivo(this.docId, 'Documentos', this.docDes, this.paginas)

    },
    watch: {
        loading(val) {
            if (!val) return;

            setTimeout(() => (this.loading = false), 3000);
        },
    },

};
</script>
<!--<style src="./src/components/pages/main/Dashboard.scss" lang="scss" />-->